import { ChangeEvent } from "react";

export interface TextAreaProps
  extends Omit<React.InputHTMLAttributes<HTMLTextAreaElement>, "onChange"> {
  label: string;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  errorText?: string;
}

export const TextArea = ({
  id,
  name,
  label,
  onChange,
  required,
  errorText,
  value,
  className,
  ...restProps
}: TextAreaProps) => {
  const error = Boolean(errorText);
  const color = error ? "failure" : "";

  return (
    <div className="mb-4">
      {label && (
        <div className="mb-2 block">
          <label
            htmlFor={name}
            className="block mb-2 text-sm font-semibold text-gray-900 dark:text-white"
          >
            {label} {required ? <span className="text-red-500">*</span> : ""}
          </label>
        </div>
      )}
      <textarea
        id={name}
        value={value}
        onChange={onChange}
        rows={10}
        color={color}
        className={`bg-border border text-gray-900 text-sm rounded-md block w-full p-2 outline-none focus:ring-0 focus:ring-offset-0 focus:ring-border focus:border-gray-300
              ${error ? "border-red-500" : "border-gray-300"}
                `}
        {...restProps}
      />
      {errorText && <p className="text-xs text-red-500 mt-1">{errorText}</p>}
    </div>
  );
};
